'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_types\uff3fchat$package$ChatExpiresAt$() {
  this.Lapp_data_types\uff3fchat$package$ChatExpiresAt$__f_defaultMake$lzy5 = null;
  this.Lapp_data_types\uff3fchat$package$ChatExpiresAt$__f_defaultMakebitmap$5 = false;
  this.Lapp_data_types\uff3fchat$package$ChatExpiresAt$__f_make$lzy5 = null;
  this.Lapp_data_types\uff3fchat$package$ChatExpiresAt$__f_makebitmap$5 = false;
  this.Lapp_data_types\uff3fchat$package$ChatExpiresAt$__f_CannotParseError$lzy2 = null;
  this.Lapp_data_types\uff3fchat$package$ChatExpiresAt$__f_CannotParseErrorbitmap$2 = false;
}
export { $c_Lapp_data_types\uff3fchat$package$ChatExpiresAt$ as $c_Lapp_data_types\uff3fchat$package$ChatExpiresAt$ };
$c_Lapp_data_types\uff3fchat$package$ChatExpiresAt$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_types\uff3fchat$package$ChatExpiresAt$.prototype.constructor = $c_Lapp_data_types\uff3fchat$package$ChatExpiresAt$;
/** @constructor */
function $h_Lapp_data_types\uff3fchat$package$ChatExpiresAt$() {
}
export { $h_Lapp_data_types\uff3fchat$package$ChatExpiresAt$ as $h_Lapp_data_types\uff3fchat$package$ChatExpiresAt$ };
$h_Lapp_data_types\uff3fchat$package$ChatExpiresAt$.prototype = $c_Lapp_data_types\uff3fchat$package$ChatExpiresAt$.prototype;
$c_Lapp_data_types\uff3fchat$package$ChatExpiresAt$.prototype.defaultMake__Lyantl_INewtype$defaultMake$ = (function() {
  if ((!this.Lapp_data_types\uff3fchat$package$ChatExpiresAt$__f_defaultMakebitmap$5)) {
    this.Lapp_data_types\uff3fchat$package$ChatExpiresAt$__f_defaultMake$lzy5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$defaultMake$(this);
    this.Lapp_data_types\uff3fchat$package$ChatExpiresAt$__f_defaultMakebitmap$5 = true;
  }
  return this.Lapp_data_types\uff3fchat$package$ChatExpiresAt$__f_defaultMake$lzy5;
});
$c_Lapp_data_types\uff3fchat$package$ChatExpiresAt$.prototype.make__Lyantl_INewtype$make$ = (function() {
  if ((!this.Lapp_data_types\uff3fchat$package$ChatExpiresAt$__f_makebitmap$5)) {
    this.Lapp_data_types\uff3fchat$package$ChatExpiresAt$__f_make$lzy5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$make$(this);
    this.Lapp_data_types\uff3fchat$package$ChatExpiresAt$__f_makebitmap$5 = true;
  }
  return this.Lapp_data_types\uff3fchat$package$ChatExpiresAt$__f_make$lzy5;
});
$c_Lapp_data_types\uff3fchat$package$ChatExpiresAt$.prototype.resolveMake__Lyantl_Make = (function() {
  return this.defaultMake__Lyantl_INewtype$defaultMake$();
});
$c_Lapp_data_types\uff3fchat$package$ChatExpiresAt$.prototype.protected_unwrap__O__O = (function(wrapped) {
  return wrapped;
});
$c_Lapp_data_types\uff3fchat$package$ChatExpiresAt$.prototype.wrap__O__O = (function(underlying) {
  return underlying;
});
$c_Lapp_data_types\uff3fchat$package$ChatExpiresAt$.prototype.CannotParseError__Lframework_data_FrameworkDateTime$Newtype$CannotParseError$ = (function() {
  if ((!this.Lapp_data_types\uff3fchat$package$ChatExpiresAt$__f_CannotParseErrorbitmap$2)) {
    this.Lapp_data_types\uff3fchat$package$ChatExpiresAt$__f_CannotParseError$lzy2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError$(this);
    this.Lapp_data_types\uff3fchat$package$ChatExpiresAt$__f_CannotParseErrorbitmap$2 = true;
  }
  return this.Lapp_data_types\uff3fchat$package$ChatExpiresAt$__f_CannotParseError$lzy2;
});
$c_Lapp_data_types\uff3fchat$package$ChatExpiresAt$.prototype.validate__Lyantl_Validate = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lyantl_Validate$().Lyantl_Validate$__f_noOp;
});
var $d_Lapp_data_types\uff3fchat$package$ChatExpiresAt$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_types\uff3fchat$package$ChatExpiresAt$, "app.data.types_chat$package$ChatExpiresAt$", ({
  Lapp_data_types\uff3fchat$package$ChatExpiresAt$: 1,
  Lyantl_INewtype: 1,
  Lyantl_Newtype: 1,
  Lyantl_Newtype$Of: 1,
  Lframework_data_FrameworkDateTime$Newtype: 1,
  Lyantl_Newtype$WithoutValidation: 1
}));
export { $d_Lapp_data_types\uff3fchat$package$ChatExpiresAt$ as $d_Lapp_data_types\uff3fchat$package$ChatExpiresAt$ };
var $n_Lapp_data_types\uff3fchat$package$ChatExpiresAt$;
function $m_Lapp_data_types\uff3fchat$package$ChatExpiresAt$() {
  if ((!$n_Lapp_data_types\uff3fchat$package$ChatExpiresAt$)) {
    $n_Lapp_data_types\uff3fchat$package$ChatExpiresAt$ = new $c_Lapp_data_types\uff3fchat$package$ChatExpiresAt$();
  }
  return $n_Lapp_data_types\uff3fchat$package$ChatExpiresAt$;
}
export { $m_Lapp_data_types\uff3fchat$package$ChatExpiresAt$ as $m_Lapp_data_types\uff3fchat$package$ChatExpiresAt$ };
//# sourceMappingURL=app.data.types_chat$package$-Chat-Expires-At$.js.map
